export default __webpack_public_path__ + "static/media/tokenomics.8a430794.svg";